import { api } from '~/shared/services/api';

import type { WorkwiseProduct } from './types';

export async function getProducts(): Promise<WorkwiseProduct[]> {
  const { data } = await api.get<WorkwiseProduct[]>(
    '/api/user-access-management/products'
  );
  return Array.isArray(data) ? data : [];
}
